import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PagoService } from 'src/app/services/pago.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { CondicionPagoService } from 'src/app/services/condicion-pago.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';

@Component({
  selector: 'app-modal-view-details-pago',
  templateUrl: './modal-view-details-pago.component.html',
  styleUrls: ['../cartola-cliente.component.scss'],
  providers: [SecurityService],
})
export class ModalViewDetailsPagoComponent implements OnInit {
  // Modales
  @ViewChild('verPago', { static: true }) modalVerPago: ModalDirective;

  // Form
  formHeader: FormGroup;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  public rutRecaudador: any;
  public nombreRecaudador: any;
  loading: boolean = false;
  pago: any = null;

  // Utils
  private log: any;
  cliente_nombre: any = null;
  condicion_pago: string = null;
  private currentPayload: any = null;
  cliente: any = null;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private pagoService: PagoService,
    private clienteProveedorService: ClienteProveedorService,
    private condicionPagoService: CondicionPagoService,
    private fileDownloadService: FileDownloadService
  ) {
    this.log = this.clog.log('CONSULTAR-PAGOS-DETAILS');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.createForms();
    this.formChangesSubscriptions();
  }

  private createForms() {
    // this.formHeader = this.fb.group({
    //   fecha_desde: [initDate, [Validators.required]],
    //   fecha_hasta: [currentDate, [Validators.required]],
    //   rutCliente: [null, []],
    //   codigo: [null, [Validators.required]],
    // });
  }

  private formChangesSubscriptions() {
    // this.formHeader.get("rutCliente").valueChanges
    //   .pipe(filter(Boolean), debounceTime(1000))
    //   .subscribe((rutCliente: string) => {
    //     this.modalSeleccionarCliente.searchByRut(rutCliente)
    //   })
  }

  loadAndShow(codigo: number, Usuario: any) {
    this.cleanup();
    this.modalVerPago.show();
    //mostrar nombre cliente y condicion de pago
    this.cliente = Usuario;
    this.cliente_nombre = Usuario.nombre;

    const inputParams = {
      entidad: {
        cliente_proveedor: {
          empresa_rut: this.rutEmpresa,
          // sucursal_codigo: this.sucursalEmpresa,
          rut: Usuario.rut,
        },
      },
    };

    this.log('fetch sucursal', JSON.stringify(inputParams));
    this.clienteProveedorService.ObtenerClienteEspecifico(inputParams, ({ respuesta }) => {
      if (respuesta != null) {
        const { direccion } = respuesta;
        this.obtenerCondicionPago(direccion.condicion_pago_codigo);
      }
    });

    this.buscar(codigo);
  }

  obtenerCondicionPago(condicion_pago: number) {
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
      },
    };
    this.condicionPagoService.obtenerCondicionPagoCompra(inputParams, ({ respuesta }) => {
      const self = this;

      if (respuesta != null) {
        const { registros } = respuesta;
        const condicion = registros.filter((x) => x.codigo == condicion_pago);
        self.condicion_pago = condicion[0].descripcion;
      }
    });
  }

  cleanup() {
    this.loading = true;
    this.pago = null;
  }

  buscar(codigo: number) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        codigo,
      },
    };

    this.currentPayload = inputParams;
    this.log('inputParams', JSON.stringify(inputParams));

    this.loading = true;
    this.pagoService.obtenerPagoEspecifico(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      this.pago = respuesta;

      this.pago.saldoDocumento.forEach((pago) => {
        pago.abono = 0;
      });
      this.pago.difereciaPago.forEach((pago) => {
        pago.pagoAUtilizar = 0;
      });
      this.rutRecaudador = this.rutService.AgregarDV(this.pago.rut_recaudador);
      this.nombreRecaudador = this.pago.nombre_recaudador;

      // this.listaMovimientos.forEach(p => {
      //   p.rutFormato = this.rutService.AgregarDV(p.cliente_proveedor_rut)
      // })

      this.calcularTotales();
      this.loading = false;
    });
  }

  calcularTotales() {
    this.pago.totales = {
      saldoDocumento: {
        monto: _.sumBy(this.pago.saldoDocumento, 'monto'),
        pago: _.sumBy(this.pago.saldoDocumento, 'pago'),
        abono: _.sumBy(this.pago.saldoDocumento, 'abono'),
        saldo: _.sumBy(this.pago.saldoDocumento, 'saldo'),
      },
      difereciaPago: {
        saldo: _.sumBy(this.pago.difereciaPago, 'saldo'),
        // pagoAUtilizar: _.sumBy(this.pago.difereciaPago, 'pagoAUtilizar'),
      },
      forma_pago: _.sumBy(this.pago.forma_pago, 'monto'),
    };
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload);
    delete inputParams.cantidadRegistrosPorPagina;
    delete inputParams.paginaActual;
    inputParams.entidad.retornaExcel = type === 'XLS';
    inputParams.entidad.retornaPDF = type === 'PDF';

    console.log('muestrame datos del cliente ', this.cliente);
    inputParams.entidad.cliente_proveedor_rut = this.cliente.rut;
    this.log('inputParams', JSON.stringify(inputParams));
    this.pagoService.obtenerPagoEspecificoPDF(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta.rutaArchivo);
    });
  }
}
